import { useEffect, useState } from "react";
import ServicioComun from "../../../../servicios/Comun";

function GenerosDropdown({
  id,
  name,
  value,
  onChange,
  permiteSeleccionar = "true",
  className = "",
  ...props
}) {
  const [generos, setGeneros] = useState([]);

  const claseFinal = `form-control ${className}`.trim();

  useEffect(() => {
    async function obtenerPaises() {
      const generos = await ServicioComun.ObtengaGeneros();
      setGeneros(generos);
    }

    obtenerPaises();
  }, []);

  return (
    <select
      id={id}
      className={claseFinal}
      disabled={!permiteSeleccionar}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      {...props}
    >
      {generos.map((item) => (
        <option key={item.id} value={item.id}>
          {item.nombre}
        </option>
      ))}
    </select>
  );
}

export default GenerosDropdown;
